import React from 'react';
import { useUserMenu } from 'react-admin';
import { setGlobalData, getGlobalData } from './globalData';
import MenuItem from '@mui/material/MenuItem';
import LockOutlined from '@mui/icons-material/LockOutlined';

const canSoftLock = () => {
  const info = getGlobalData('info');
  if (!info || info.back !== true || !info.parentexpiry || parseInt(info.db_id, 10) <= 0) {
    return false;
  }
  return new Date(info.parentexpiry) > new Date();
}

const SoftLogout = () => {
  const { onClose } = useUserMenu();

  const lock = () => {
    if (!canSoftLock()) return;
    onClose();
    const info = getGlobalData('info');
    const nextInfo = {...info, expiry: new Date().toISOString()};
    setGlobalData({info: nextInfo});
    localStorage.setItem('info', JSON.stringify(nextInfo));
    window.setTimeout(() => window.dispatchEvent(new Event('bw-session-lock')), 50);
  };

  if (!canSoftLock()) return null;
  return (
    <MenuItem onClick={lock}>
      <LockOutlined style={{paddingRight:"1rem"}} />
      Lock session
    </MenuItem>
  );
}

export default SoftLogout;
